import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=20c077aa&scoped=true&"
import script from "./gallery.ts?vue&type=script&lang=ts&"
export * from "./gallery.ts?vue&type=script&lang=ts&"
import style0 from "./gallery.scss?vue&type=style&index=0&id=20c077aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c077aa",
  null
  
)

export default component.exports